export const shipTypesDropdownValues = [
    { label: 'Sleephopperzuiger', value: 'HopperDredger' },
    { label: 'Kraanschip', value: 'GrabDredger' },
    { label: 'Ploegboot', value: 'BedLeveller' },
    { label: 'Waterinjectievaartuig', value: 'WaterInjection' },
    { label: 'Splijtbak', value: 'Barge' },
    { label: 'Peilboot', value: 'MultibeamSurvey' },
    { label: 'Inspectievaartuig', value: 'SurveyVessel' },
];

export function shipTypeEnumToReadableString(s: string) {
    return shipTypesDropdownValues.find(x => x.value === s)?.label;
}
